import React from 'react';
import { Grid } from '@material-ui/core';
import axios from 'axios';
import { validationSchemaForGeneralInfo } from '../balance-cancellation/FormModel/validationSchema';
import { formInitialValuesForGeneralInfo } from '../balance-cancellation/FormModel/formInitialValues';
import { Formik, Form } from 'formik';
import { CommonStyles } from '../balance-cancellation/CommonStyles';
import GeneralForm from './GeneralForm';
import { base64Authorization } from '../utils/CommonFunctions';
import { PropTypes } from 'prop-types';
import { generateuuid } from '../../../app/CommonFunction';
import { API_CONFIG } from '../../../config/apiconfig';
const useCommonStyles = CommonStyles();
const GeneralInfo = (props) => {
  const CommonCssStyles = useCommonStyles();
  const {
    englishBot,
    sessionID,
    setServiceFormTrigger,
    setGeneralFormTrigger,
    formInProcessTrigger,
    handeButtonLinkMessage,
    setCustomerDetails,
    spinnerHandler,
    setShowRegisterCustomerButton,
    token,
    getAccessToken,
  } = props;

  function _handleSubmit(values, actions) {
    setGeneralFormTrigger(false);
    formInProcessTrigger(false);
    setShowRegisterCustomerButton(true);
    const params = {
      sessionId: sessionID,
      customerEmail: values.personEmail,
      mobileNumber: `${values.mobileNumber}`,
      customerName: `${values.firstName} ${values.lastName}`,
      lineOfBusiness: values.accountType,
    };
    // axios
    //   .post(
    //     process.env.REACT_APP_TOKEN_SERVICE_URL,
    //     {},
    //     {
    //       headers: {
    //         Authorization: `Basic ${base64Authorization}`,
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //       },
    //     }
    //   )
    //   .then((response) => {
    const uuid = generateuuid();
    axios
      .post(`${API_CONFIG.USER_FORM_URL}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_X_API_KEY,
          appid: 'comms',
          sessionId: sessionID,
          source: 'Chatbot',
          lang: englishBot ? 'ENG' : 'ESP',
          uuid,
        },
      })
      .then((res) => {
        const { data } = res;
        if (data.messages && data.messages[0].content.includes('templateType')) {
          const listPickerData = JSON.parse(data.messages[0].content);
          setCustomerDetails(listPickerData.data.content.sessionAttributes);
          setTimeout(() => {
            spinnerHandler(false);
            handeButtonLinkMessage(
              { text: listPickerData.data.content.title, value: '', isButtonMessage: false },
              false
            );
          }, 1000);
        }
      })
      .catch((err) => {
        if (
          err.message === 'Request failed with status code 403' ||
          err.message === 'Request failed with status code 401'
        ) {
          getAccessToken(true, 'liveAgent', params);
        }
      });
    // })
    // .catch();
  }

  return (
    <Formik
      initialValues={formInitialValuesForGeneralInfo}
      validationSchema={validationSchemaForGeneralInfo}
      onSubmit={_handleSubmit}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Grid item xs={12} className={CommonCssStyles.steps_grid} style={{ margin: '10px' }}>
            <GeneralForm
              englishBot={englishBot}
              setServiceFormTrigger={setServiceFormTrigger}
              setGeneralFormTrigger={setGeneralFormTrigger}
              spinnerHandler={spinnerHandler}
            />
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

GeneralInfo.propTypes = {
  englishBot: PropTypes.bool,
  sessionID: PropTypes.string,
  setServiceFormTrigger: PropTypes.func,
  setGeneralFormTrigger: PropTypes.func,
  formInProcessTrigger: PropTypes.func,
  handeButtonLinkMessage: PropTypes.func,
  setCustomerDetails: PropTypes.object,
  spinnerHandler: PropTypes.func,
  setShowRegisterCustomerButton: PropTypes.func,
};
export default GeneralInfo;
